export const slugify = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const COURSES = [
  { value: "all", label: "All courses" },
  { value: "bams", label: "BAMS (UG)" },
  { value: "pg", label: "Any PG (MD/MS)" },
  { value: "md", label: "MD (Ayurveda)" },
  { value: "ms", label: "MS (Ayurveda)" },
];

export const SORTS = [
  { value: "default", label: "Sort: State order" },
  { value: "name", label: "Name A–Z" },
  { value: "ug", label: "Most BAMS seats" },
  { value: "pg", label: "Most PG seats" },
  { value: "scholars", label: "Most scholars" },
];

export const TYPE_GROUPS = [
  { value: "all", label: "All types" },
  { value: "govt", label: "Government / Central" },
  { value: "aided", label: "Grant-in-aid / Aided" },
  { value: "private", label: "Private" },
  { value: "deemed", label: "Deemed University" },
];

export function typeGroup(t = "") {
  const s = t.toLowerCase();
  if (s.includes("deemed")) return "deemed";
  if (s.includes("aid")) return "aided";
  if (s.includes("private")) return "private";
  return "govt";
}

export function filterColleges(list, f) {
  const q = f.q.trim().toLowerCase();
  return list.filter((c) => {
    if (f.state && c.slug !== f.state) return false;
    if (f.type !== "all" && typeGroup(c.type) !== f.type) return false;
    const degrees = c.pg_subjects.map((s) => s.degree);
    if (f.course === "bams" && !c.ug_seats) return false;
    if (f.course === "pg" && !c.pg_seats) return false;
    if (f.course === "md" && !degrees.includes("MD")) return false;
    if (f.course === "ms" && !degrees.includes("MS")) return false;
    if (f.subject !== "all" && !c.pg_subjects.some((s) => s.name === f.subject)) return false;
    if (q && !`${c.name} ${c.address} ${c.district} ${c.college_id}`.toLowerCase().includes(q)) return false;
    return true;
  });
}

export function sortColleges(list, sort) {
  const arr = [...list];
  if (sort === "ug") arr.sort((a, b) => b.ug_seats - a.ug_seats);
  else if (sort === "pg") arr.sort((a, b) => b.pg_seats - a.pg_seats);
  else if (sort === "name") {
    const key = (c) => c.name.replace(/^\([^)]*\)\s*|^[^A-Za-z]+/, "");
    arr.sort((a, b) => key(a).localeCompare(key(b)));
  }
  else if (sort === "scholars") arr.sort((a, b) => b.scholar_count - a.scholar_count);
  return arr;
}

export function downloadCsv(list, filename) {
  const head = ["College ID", "College", "State", "District", "Type", "UG seats (BAMS)", "PG seats", "PG subjects", "Address", "Permission"];
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const rows = list.map((c) => [c.college_id, c.name, c.state, c.district, c.type, c.ug_seats, c.pg_seats,
    c.pg_subjects.map((s) => `${s.name} (${s.degree})`).join("; "), c.address, c.permission].map(esc).join(","));
  const blob = new Blob([[head.map(esc).join(","), ...rows].join("\n")], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
